import React from 'react';
import { Label } from 'reactstrap';
import { Flex, Spinner } from '@chakra-ui/react';

export const LoadingSpinner = ({ label, isLoading = true }) => {
	return (
		<Flex paddingTop={'10%'}>
			<Label>{label || 'No se encontraron registros a mostrar'}</Label>
		</Flex>
	);
};

export default LoadingSpinner;
